<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'Support Page',
          to: {
            name: 'Support'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'SupportEdit',
            params: {
              id: $route.params.id,
            },
          }
        },
        {
          name: 'Edit Warranty Policy Content',
          to: {
            name: 'G-1-1b-3-1__SupportEdit_B2C_WarrantyPolicy_ContentEdit',
            params: {
              id: $route.params.id,
            },
          },
        },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯 Warranty Policy</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>

    <div class="block px-5 py-5">
      <!-- support.warranty_policy.policies -->
      <PageCollapse v-for="(item, i) in support.warranty_policy.policies" :key="i">
        <template v-slot:head>
          <h3 class="mr-auto">Policy {{ i + 1 }}</h3>
        </template>
        <template v-slot:actions>
          <div class="ml-auto">
            <button class="btn square mr-10px" @click="deleteItem(item)">
              <v-icon class="ink-02-medium--text">delete</v-icon>
            </button>
            <button class="btn square mr-10px" @click="downItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
            </button>
            <button class="btn square" @click="upItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
            </button>
          </div>
        </template>
        <template v-slot:body>
          <!-- Basic section -->
          <div>
            <!-- Divider -->
            <label class="form-item d-flex py-5">
              <div class="w-174px mr-6">
                <h4>Divider</h4>
              </div>
              <div class="flex-grow-1 flex-basis-0">
                <FormSwitch v-model="item.divider"></FormSwitch>
              </div>
            </label>
            <!-- Title -->
            <label class="form-item d-flex py-5">
              <div class="w-174px mr-6">
                <h4>Title</h4>
              </div>
              <div class="flex-grow-1 flex-basis-0 my-n2">
                <v-text-field
                  v-model="item.title"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </label>
            <!-- Content -->
            <div class="d-flex px-5 pt-5 mb-8">
              <div class="w-174px mr-6">
                <h4>Content</h4>
              </div>
              <div class="flex-grow-1 flex-basis-0 my-n2">
                <editor
                  :key="item.id"
                  v-model="item.content"
                  :plugins="'link image'"
                  :toolbar="'link bold image'"
                />
              </div>
            </div>
          </div>
        </template>
      </PageCollapse>
      <!-- add item -->
      <div class="mt-5">
        <button class="btn btn-outlined w-100 justify-start" @click="addItem">
          <v-icon class="primary--text mr-2">add_circle</v-icon>
          <span>添加一組Divider+Title+Content</span>
        </button>
      </div>
    </div>

    <!-- page-actions -->
    <div class="page-actions">
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import PageCollapse from '@/components/PageCollapse.vue';
import Editor from '@/components/TinymceEditor.vue';
import FormSwitch from '@/components/FormSwitch.vue';

export default {
  components: {
    Breadscrumbs,
    PageCollapse,
    Editor,
    FormSwitch,
  },
  computed: {
    ...mapState('support', [
      'support',
    ]),
  },
  methods: {
    addItem() {
      const template = {
        id: null,
        title: '',
        content: '',
        divider: false,
      };
      this.support.warranty_policy.policies.push(template);
    },
    deleteItem(item) {
      const index =
        this.support.warranty_policy.policies.map((option) => option.id).indexOf(item.id);
      this.support.warranty_policy.policies.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.support.warranty_policy.policies.length - 1) {
        this.support.warranty_policy.policies.splice(i, 1);
        this.support.warranty_policy.policies.unshift(item);
        return;
      }
      // item become next index
      this.support.warranty_policy.policies.splice(i, 1);
      this.support.warranty_policy.policies.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.support.warranty_policy.policies.splice(i, 1);
        this.support.warranty_policy.policies.push(item);
        return;
      }
      // item become previous index
      this.support.warranty_policy.policies.splice(i, 1);
      this.support.warranty_policy.policies.splice(i - 1, 0, item);
    },
    // actions
    cancelHandler() {
      this.$router.go(-1);
    },
    saveHandler() {
      this.$router.go(-1);
    },
  },
};
</script>

<style></style>
